import { RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Themes } from '../../constants';
import { getThemeColor } from '../../utils/common';

import type { RadioGroupProps } from '@mui/material';

interface FHRadioGroupProps extends RadioGroupProps {
  colorTheme?: Themes;
  coloredBackground?: boolean;
  rowGap?: string;
}

const StyledRadioGroup = styled(RadioGroup, {
  shouldForwardProp: (prop) =>
    prop !== 'colorTheme' && prop !== 'coloredBackground' && prop !== 'rowGap',
})<FHRadioGroupProps>(({ colorTheme, coloredBackground, rowGap }: any) => ({
  '& .MuiFormControlLabel-root': {
    marginBottom: rowGap ? rowGap : 8,
    marginLeft: 0,
    marginRight: 0,
  },

  '& .MuiFormControlLabel-label': {
    marginLeft: '8px',
    marginRight: 0,
  },

  '& .MuiRadio-root': {
    backgroundColor: coloredBackground ? getThemeColor(colorTheme).light3 : 'transparent',
    boxShadow: coloredBackground ? `0px 4px 4px ${getThemeColor(colorTheme).light2}` : 'none',
    padding: 0,
    '& > span': {
      marginLeft: '-2px', // to adjust mui span which wraps internal svg
      marginTop: '-2px', // to adjust mui span which wraps internal svg
      width: 21,
      height: 21,
    },
  },
  '& .MuiSvgIcon-root': {
    color: getThemeColor(colorTheme).primary,

    '&.Mui-checked': {
      color: getThemeColor(colorTheme).primary,
    },
  },
}));

function FHRadioGroup(props: FHRadioGroupProps) {
  const { colorTheme = Themes.Primary, coloredBackground = false, children, rowGap } = props;

  return (
    <StyledRadioGroup
      rowGap={rowGap}
      colorTheme={colorTheme}
      coloredBackground={coloredBackground}
      {...props}
    >
      {children}
    </StyledRadioGroup>
  );
}
export default FHRadioGroup;
